'use strict';

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./utils'),
    deepEqual = _require.deepEqual;

var sum = function sum(acc, val) {
  return acc + val;
};
/**
 * G-Counter
 *
 * Operation-based Increment-Only Counter CRDT
 *
 * Sources: 
 * "A comprehensive study of Convergent and Commutative Replicated Data Types"
 * http://hal.upmc.fr/inria-00555588/document, "3.1.1 Op-based counter and 3.1.2  State-based increment-only Counter (G-Counter)"
 */


var GCounter = /*#__PURE__*/function () {
  function GCounter(id, counter) {
    _classCallCheck(this, GCounter);

    this.id = id;
    this._counters = counter ? counter : {};
    this._counters[this.id] = this._counters[this.id] ? this._counters[this.id] : 0;
  }

  _createClass(GCounter, [{
    key: "value",
    get: function get() {
      return Object.values(this._counters).reduce(sum, 0);
    }
  }, {
    key: "increment",
    value: function increment(amount) {
      if (amount && amount < 1) return;
      if (amount === undefined || amount === null) amount = 1;
      this._counters[this.id] = this._counters[this.id] + amount;
    }
  }, {
    key: "merge",
    value: function merge(other) {
      var _this = this;

      // Go through each counter in the other counter
      Object.entries(other._counters).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            id = _ref2[0],
            value = _ref2[1];

        // Take the maximum of the counter value we have or the counter value they have
        _this._counters[id] = Math.max(_this._counters[id] || 0, value);
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        id: this.id,
        counters: this._counters
      };
    }
  }, {
    key: "isEqual",
    value: function isEqual(other) {
      return GCounter.isEqual(this, other);
    }
  }], [{
    key: "from",
    value: function from(json) {
      return new GCounter(json.id, json.counters);
    }
  }, {
    key: "isEqual",
    value: function isEqual(a, b) {
      if (a.id !== b.id) return false;
      return deepEqual(a._counters, b._counters);
    }
  }]);

  return GCounter;
}();

module.exports = GCounter;